import { MRT_ColumnDef, createMRTColumnHelper } from "material-react-table";
import { useTranslation } from "react-i18next";
import { extendColumnsByJsonAttributes } from "src/components/Grid/hooks/columnsExtension/useGridColumns";
import { CompanyGrid } from "src/api/client-api/company/useGetAllOrganization";
import { useFoodpilotContext } from "src/context/FoodpilotContext";
import { StringFilter } from "src/components/Grid/filters/StringFilter";
import { JSON_ATTRIBUTE_ENTITY_CLASS } from "src/constants";

export type SupplierColumns = MRT_ColumnDef<CompanyGrid, any>[];

export const useSupplierColumns = (data?: CompanyGrid[]): SupplierColumns => {
    const { t } = useTranslation();
    const { entitiesJsonAttributes } = useFoodpilotContext();

    const columnHelper = createMRTColumnHelper<CompanyGrid>();
    const mrt_columns: SupplierColumns = [
        columnHelper.accessor((row) => row.name, {
            grow: false,
            id: "name",
            header: t("name_1"),
            // Cell: (value) => {
            //     // const url = URLHandler.supplier.;
            //     return (
            //         <GridLink
            //             // to={url}
            //             label={value.renderedCellValue}
            //         />
            //     )
            // },
            Filter: (mrtProps) => {
                return <StringFilter mrtProps={mrtProps} />;
            },
            enableColumnFilter: true,
            enableSorting: true,
        }),
        columnHelper.accessor((row) => row.clientId ?? "-", {
            id: "clientId",
            header: t("supplier_code"),

            Filter: (mrtProps) => {
                return <StringFilter mrtProps={mrtProps} />;
            },
            enableColumnFilter: true,
            enableSorting: true,
        }),
    ];

    const organizationJsonAttributes = entitiesJsonAttributes?.[JSON_ATTRIBUTE_ENTITY_CLASS.organization] || [];

    // Add dynamic JSON attribute columns
    extendColumnsByJsonAttributes(mrt_columns, organizationJsonAttributes, data);

    return mrt_columns;
};
